import {moveIoActions} from '@local/redux/slice/pages/moveIo';
import {loginActions} from '@local/redux/slice/pages/login';
import {adminSettingActions} from '@local/redux/slice/pages/adminSetting';
import {employeesActions} from '@local/redux/slice/pages/employees';
import {employeesUploadActions} from '@local/redux/slice/pages/employeesUpload';
import {moveIoUploadActions} from '@local/redux/slice/pages/moveIoUpload';
import {propertyDetailActions} from '@local/redux/slice/pages/propertyDetail';
import {useEffect, useRef} from 'react';
import {RouterHolder} from '@local/logics/global/routerHolder';
import {DispatchHolder} from '@local/logics/global/dispatchHolder';
import {useRouter} from 'next/router';
import {signupActions} from '@local/redux/slice/pages/signupSlice';

export const useStateCleaner = () => {
  // 基本的にuseRouterは使わないけどここはトリガーに必要なので取得する
  // クラスにわたす必要はないためuseEffectのトリガーとして使うだけ。
  const router = useRouter();
  const cleanerRef = useRef(new StateCleaner());
  useEffect(() => {
    // setRouterの先でdispatch実行してたら怒られた。
    // 内容はこれ。
    // https://ja.reactjs.org/blog/2020/02/26/react-v16.13.0.html#warnings-for-some-updates-during-render
    // useEffectの中だと大丈夫らしいから関数分けてここで実行。
    cleanerRef.current.clean();
  }, [router]);
};

class StateCleaner {
  private pathname: string = '';
  clean = () => {
    if (this.pathname !== RouterHolder.router.pathname) {
      const action = actions.find(a => a.regex.test(this.pathname));
      this.pathname = RouterHolder.router.pathname;
      if (action) {
        console.log('clean', action.regex);
        for (const clear of action.clearActions) {
          DispatchHolder.dispatch(clear());
        }
      }
    }
  };
}

// slice/pages 以下のアクションを全部持ってくる方法はないんだろうか
// 絶対もれるわこれ
// pages以下を再帰的にdirして一覧作る処理をgenに入れないとやばいから早めにやる
// あれこれ対応できるようにactionは配列にしておく。
// これの型をgeneratorで生成して、漏れてたらコンパイル通らないようにするのがよさそう。
// 意図的に何もしないのであれば空配列にするだけだし。
const actions: {regex: RegExp; clearActions: (() => any)[]}[] = [
  {regex: /^\/settings\/admin$/, clearActions: [adminSettingActions.clear]},
  {regex: /^\/employees$/, clearActions: [employeesActions.clear]},
  {regex: /^\/employees\/upload$/, clearActions: [employeesUploadActions.clear]},
  {regex: /^\/login$/, clearActions: [loginActions.clear]},
  {regex: /^\/signup$/, clearActions: [signupActions.clear]},
  {regex: /^\/move-io$/, clearActions: [moveIoActions.clear]},
  {regex: /^\/move-io\/upload$/, clearActions: [moveIoUploadActions.clear]},
  {regex: /^\/move-io\/detail\/[^/]+$/, clearActions: [propertyDetailActions.clear]},
];
